import { render, staticRenderFns } from "./CustomCarrierQuotationLC.vue?vue&type=template&id=14c8ccc8&scoped=true&"
import script from "./CustomCarrierQuotationLC.vue?vue&type=script&lang=js&"
export * from "./CustomCarrierQuotationLC.vue?vue&type=script&lang=js&"
import style0 from "./CustomCarrierQuotationLC.vue?vue&type=style&index=0&id=14c8ccc8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c8ccc8",
  null
  
)

export default component.exports